import { FC } from 'react';
import styled from 'styled-components';
import { Badge } from 'antd';
import { colorPrimary } from '@atlas-frontend/design-tokens';

export interface AlgorithmTargetMappingsGraphEdgeLabelProps {
  x: number;
  y: number;
  ruleCode: string;
}

export const AlgorithmTargetMappingsGraphEdgeLabel: FC<
  AlgorithmTargetMappingsGraphEdgeLabelProps
> = (props) => (
  <div
    style={{
      position: 'absolute',
      transform: `translate(${props.x}px,${props.y}px)`,
    }}
  >
    <StyledBadge count={props.ruleCode} color={colorPrimary} />
  </div>
);

const StyledBadge = styled(Badge)`
  transform: translate(-50%, -50%);
  vertical-align: initial !important;
`;
